import styled from '@emotion/styled';
import TypographyComponent from 'components/Typography/Typography';
import { theme } from 'theme';

export const FilesWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 20px;
`;

export const FileLink = styled.div`
  display: flex;
  flex-direction: column;
  width: 48%;
  padding-right: 16px;
  svg {
    width: 56px;
    margin-right: 4px;
    flex-shrink: 0;
  }
`;
export const FileInfo = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  max-width: 80%;
`;
export const FileTitle = styled(TypographyComponent)`
  color: ${theme.palette.primary.main};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0;
`;
export const FileDescription = styled(TypographyComponent)`
  font-weight: 600;
  color: ${theme.palette.primary.main};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0;
`;

export const InnerWrapper = styled.a`
  display: flex;
  &:hover {
    svg {
      filter: brightness(0.9);
    }
  }
`;
export const IconWrapper = styled.div`
  flex-shrink: 0;
`;

export const FileData = styled.a`
  font-size: 12px;
  line-height: 20px;
  margin-left: 60px;
  margin-top: -16px;
  padding: 0;
  color: ${theme.palette.grey[500]};
  background: none;
  transition: background 0.1s ease-out;
  user-select: none;
  cursor: pointer;
  -webkit-user-drag: none;
  user-drag: none;
  span {
    color: ${theme.palette.primary.main};
  }
  &:hover {
    span {
      text-decoration: underline;
    }
  }
`;
